// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.gender-filter .sk-select {\n  background-color: #fff;\n}\n.gender-filter .sk-select__value {\n  color: #333;\n  font-weight: normal;\n  font-size: 13px;\n}\n.gender-filter {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
